// Ícono «refresh» del botón «Reenviar» (handoff §3). Mismo trazo que
// components/icons.tsx (24/1.6, currentColor, aria-hidden); vive aquí
// porque icons.tsx es compartido y esta ronda no lo toca. Si otra
// pantalla lo necesita, se promueve a Icon.Refresh.

export function RefreshIcon({ s = 14 }: { s?: number }) {
  return (
    <svg
      width={s}
      height={s}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M20 12a8 8 0 1 1-2.3-5.7" />
      <path d="M20 4v5h-5" />
    </svg>
  );
}
